module.exports = __webpack_public_path__ + "img/Radio_Button_Filled_White.726e966d.svg";